export default __webpack_public_path__ + "static/583-eb4f431720fadbb2fba70ad8040b0ad7.gif";